import { AVATAR_SIZES } from 'visitor-ui-component-library/avatar/constants/AvatarSizes';
import InitialMessageAvatars from './components/InitialMessageAvatars';
import styled, { ThemeContext } from 'styled-components';
import { useContext } from 'react';
import AIBotAvatarIcon from './components/AIBotAvatarIcon';
import { SMALL, MEDIUM } from 'visitor-ui-component-library/constants/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
const getAvatarHeightAboveBubble = isMobile => isMobile ? AVATAR_SIZES[SMALL] - 16 : AVATAR_SIZES[MEDIUM] - 16;
const IconWrapper = styled.div.withConfig({
  displayName: "WelcomeMessageAvatars__IconWrapper",
  componentId: "sc-306kby-0"
})(["display:inline-flex;vertical-align:middle;position:absolute;left:50%;top:", ";transform:translateX(-50%);"], ({
  isAIChatBot,
  mobile
}) => isAIChatBot ? '-40px' : `-${getAvatarHeightAboveBubble(mobile)}px`);
const WelcomeMessageAvatars = ({
  chatHeadingConfig,
  chatHeadingResponders,
  isAIChatBot,
  mobile,
  onClick
}) => {
  const theme = useContext(ThemeContext);
  return /*#__PURE__*/_jsx(IconWrapper, {
    isAIChatBot: isAIChatBot,
    mobile: mobile,
    onClick: onClick,
    children: isAIChatBot ? /*#__PURE__*/_jsx(AIBotAvatarIcon, {
      width: 56,
      height: 56,
      color: theme.colors.primary
    }) : /*#__PURE__*/_jsx(InitialMessageAvatars, {
      chatHeadingConfig: chatHeadingConfig,
      chatHeadingResponders: chatHeadingResponders,
      mobile: mobile
    })
  });
};
WelcomeMessageAvatars.displayName = 'WelcomeMessageAvatar';
export default WelcomeMessageAvatars;